import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Bookmark = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
      viewBox="0 0 16 16"
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <path d="M4 0C2.9 0 2 .9 2 2v14l6-3 6 3V2c0-1.1-.9-2-2-2H4z" stroke={stroke} />
    </svg>
  );
};

Bookmark.displayName = 'Bookmark';
